import styled from 'styled-components';

import {
  CONVERSATION_LEFT_PADDING,
  CONVERSATION_RIGHT_PADDING,
  SIDEBAR_WIDTH,
} from '@web/conversations/consts/layout';

const GAP = 20;

export const Wrapper = styled.section`
  background-color: ${({ theme }) => theme.colors.white};
  display: grid;
  grid-template:
    'header header' 75px
    'main sidebar' 1fr
    'footer sidebar' min-content /
    1fr min-content;
  height: 100%;
  padding: 0 ${GAP}px ${GAP}px;
  position: relative;
  transition: all 5s ease;
`;

export const Header = styled.header`
  border-bottom: 1px solid ${({ theme }) => theme.colors.separatorOnWhite};
  grid-area: header;
  padding: 0 0 0 ${CONVERSATION_LEFT_PADDING}px;
`;

export const Main = styled.main`
  grid-area: main;
  overflow: hidden;
  padding: 0 0 30px ${CONVERSATION_LEFT_PADDING}px;
`;

export const Sidebar = styled.aside`
  grid-area: sidebar;
  overflow: hidden;
  padding-left: ${GAP}px;
`;

type SidebarInnerProps = {
  isCollapsed?: boolean;
};
export const SidebarInner = styled.div<SidebarInnerProps>`
  height: 100%;
  transition: width 0.25s ease;
  width: ${({ isCollapsed = false }) => (isCollapsed ? 0 : `${SIDEBAR_WIDTH}px`)};
`;

export const Footer = styled.div`
  grid-area: footer;
  isolation: isolate;
  min-width: 0;
  padding: 0 ${CONVERSATION_RIGHT_PADDING}px 0 ${CONVERSATION_LEFT_PADDING}px;
  position: relative;
`;
